import React, { useState, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography, TextField } from "@mui/material";
import './MetaFieldForm.css';
export const MetaFieldForm = ({ metafields }) => {

  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const createFields = () => {
    setLoading(true);
    let temp = [];
    if (metafields) {
      metafields.map((item) => {
        if (item.type == "object") {
          let keys = Object.keys(item.value);
          keys.map((key, index) => {
            temp.push({
              label: key,
              value: item.value[index]
            });
          });
        } else if (item.type == "array") {
          item.value.map((item) => {
            Object.keys(item).map((key, index) => {
              temp.push({
                label: key,
                value: item[key]
              });
            });
          });
        } else {
          temp.push({
            label: item.key,
            value: item.value
          });
        }
      });

      setFields(temp);
    }

  };


  useEffect(() => {

    createFields();


  }, []);


  useEffect(() => {

    if (fields.length > 0) {
      setLoading(false);
    }
  }, [fields.length]);

  return (
    <Box className="Box2">
      {loading ? (<CircularProgress />) : fields.map((item, index) => {
        return (
          <TextField key={index} className="TextField2 mt-10" id="outlined-basic" label={item.label || ''} value={item.value || ''} variant="outlined" InputLabelProps={{ shrink: metafields ? true : false }} />
        );
      })}




    </Box>
  );
};

// {
//   "key": "customer_email",
//     "value": "email@address.com",
//       "value_type": null,
//         "type": "string";
// }